import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "useDarkMode", "isDarkMode", "theme"];
import React, { createContext, useState, useEffect, useCallback } from 'react';
import { addCssRules, removeCssStyleDom } from '@arco-design/mobile-utils';
export var defaultContext = {
  prefixCls: 'arco',
  system: '',
  useDarkMode: false,
  isDarkMode: false
};
export var GlobalContext = /*#__PURE__*/createContext(defaultContext);

/**
 * 全局数据控制组件，用于替换全局数据。
 * @type 其他
 * @name 全局配置
 */
export default function ContextProvider(props) {
  var children = props.children,
      useDarkMode = props.useDarkMode,
      isDarkMode = props.isDarkMode,
      theme = props.theme,
      restProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useState = useState(),
      isDarkModeState = _useState[0],
      setIsDarkModeState = _useState[1];

  var changeDarkMode = useCallback(function (res) {
    return setIsDarkModeState(res.matches);
  }, []);
  useEffect(function () {
    var matchMedia = window.matchMedia('(prefers-color-scheme: dark)');

    if (useDarkMode) {
      var dark = matchMedia.matches;
      setIsDarkModeState(dark);

      if (typeof matchMedia.addEventListener === 'function') {
        matchMedia.addEventListener('change', changeDarkMode);
      } else if (typeof matchMedia.addListener === 'function') {
        matchMedia.addListener(changeDarkMode);
      }
    }

    return function () {
      if (useDarkMode) {
        if (typeof matchMedia.removeEventListener === 'function') {
          matchMedia.removeEventListener('change', changeDarkMode);
        } else if (typeof matchMedia.removeListener === 'function') {
          matchMedia.removeListener(changeDarkMode);
        }
      }
    };
  }, [useDarkMode]);
  useEffect(function () {
    if (!theme) {
      return;
    }

    addCssRules('arcoCustomTheme', theme);
    return function () {
      removeCssStyleDom('arcoCustomTheme');
    };
  }, [theme]);
  return /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: _extends({}, defaultContext, restProps, {
      isDarkMode: isDarkMode === void 0 ? isDarkModeState : isDarkMode,
      useDarkMode: useDarkMode
    })
  }, children);
}
export var ContextLayout = GlobalContext.Consumer;